/* import __COLOCATED_TEMPLATE__ from './account-security.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';

interface Args {}

interface Signature {
  Args: Args;
  Element: never;
}

export default class AccountSecurity extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get title() {
    return this.intl.t('new-settings.submenu.personal.preferences');
  }

  get hasMultilingualGlossaryPage() {
    return this.appService.app.canUseFeature('multilingual-glossary-page');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Personal::AccountSecurity': typeof AccountSecurity;
  }
}
